/**
 * Acuerdos-Con-Gestores API
 * Acuerdos-Con-Gestores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoseedorDTO } from './poseedorDTO';
import { CodigoLerDTO } from './codigoLerDTO';
import { AcuerdoIndirectoDTO } from './acuerdoIndirectoDTO';


export interface ConsentimientoCreatePayloadDTO { 
    acuerdoIndirecto?: AcuerdoIndirectoDTO;
    codigoDocumento?: string;
    razonSocial?: string;
    tipoDocumentoFirmante?: ConsentimientoCreatePayloadDTO.TipoDocumentoFirmanteEnum;
    codigoDocumentoFirmante?: string;
    nombreFirmante?: string;
    apellidosFirmante?: string;
    poseedores?: Array<PoseedorDTO>;
    codigoLer?: Array<CodigoLerDTO>;
}
export namespace ConsentimientoCreatePayloadDTO {
    export type TipoDocumentoFirmanteEnum = 'NIF' | 'DNI' | 'NIE';
    export const TipoDocumentoFirmanteEnum = {
        Nif: 'NIF' as TipoDocumentoFirmanteEnum,
        Dni: 'DNI' as TipoDocumentoFirmanteEnum,
        Nie: 'NIE' as TipoDocumentoFirmanteEnum
    };
}


